@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;
@use '@hevoio/hevo-ui-toolkit/styles/mixins' as hevo-toolkit-mixins;
@import '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils';

.tabPanel {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

// used in workspace tab as well
.boxHeader {
  padding-top: hevo-toolkit-variables.$spacer;
  padding-bottom: hevo-toolkit-variables.$spacer;
  height: auto;
}

.teamNameContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.teamNameContainerEditMode {
  align-items: flex-start;
}

.teamNameView {
  display: flex;
  align-items: center;
  margin-top: hevo-toolkit-variables.$spacer * 0.25;
}

.teamThumbnail {
  :global {
    @include hevo-toolkit-mixins.thumbnail-container(20px, 10px, false, true);
  }
  background: hevo-toolkit-variables.$primary-faded;
  color: hevo-toolkit-variables.$primary;
  margin-right: hevo-toolkit-variables.$spacer * 0.75;
}

.dropdownHelperAdornment {
  min-width: 210px;
}

.editTeamNameContainer {
  display: flex;
  align-items: flex-start;
  margin-top: hevo-toolkit-variables.$spacer * 0.25;
}

// used in workspace tab as well
.inviteSection {
  padding: hevo-toolkit-variables.$spacer * 0.25 hevo-toolkit-variables.$spacer * 1.25;
  border-bottom: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  display: flex;
  align-items: center;
  background: hevo-toolkit-variables.$surface-bg;
  .label {
    margin-right: hevo-toolkit-variables.$spacer * 1.25;
    flex-grow: 1;
  }
}

.inviteInput {
  display: flex;
  justify-content: end;
  width: 400px;
}

// used in workspace tab as well
.inviteInputContainer {
  flex-grow: 1;
  max-width: 400px;
  display: flex;
  justify-content: flex-end;
}

// used in workspace tab as well
.member {
  padding: hevo-toolkit-variables.$spacer hevo-toolkit-variables.$spacer * 1.25;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

// used in workspace tab as well
.userImgContainer {
  @include hevo-toolkit-mixins.thumbnail-container(35px, -1px, false, true);
  color: hevo-toolkit-variables.$light-text;
  margin-right: hevo-toolkit-variables.$spacer;
  font-weight: hevo-toolkit-variables.$font-weight-bold;
  text-transform: uppercase;
}

// used in workspace tab as well
.memberNameWrapper {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

// used in workspace tab as well
.memberActions {
  display: flex;
  align-items: center;
  padding-right: hevo-toolkit-variables.$spacer * 2;
  position: relative;
  width: 240px;
}

.dropdownHelperAdornment {
  overflow-y: scroll !important;
}

.privilegeDropdown,
.privilegeDisplay {
  width: 196px;
}

.privilegeDisplay {
  font-weight: hevo-toolkit-variables.$font-weight-medium;
  padding-left: hevo-toolkit-variables.$spacer;
  padding-right: hevo-toolkit-variables.$spacer;
}

// used in workspace tab as well
.dropdownTrigger {
  position: absolute !important;
  right: -0.625 * hevo-toolkit-variables.$spacer;
  top: 50%;
  transform: translateY(-50%);
}

.inviteMemberPopupWrapper {
  height: 100vh;
  width: 100vw;
  position: relative;
  padding: hevo-toolkit-variables.$spacer * 2.5 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: scroll;

  .closeButton {
    position: absolute;
    top: hevo-toolkit-variables.$spacer * 1.25;
    right: hevo-toolkit-variables.$spacer * 1.25;
    color: hevo-toolkit-variables.$text-default;
  }

  .header {
    margin-top: hevo-toolkit-variables.$spacer * 1.25;
    color: hevo-toolkit-variables.$text-default;
    @include typography-level-to-styles(typography-config(), title-3);
  }

  .subHeader {
    margin: hevo-toolkit-variables.$spacer * 0.25 0 hevo-toolkit-variables.$spacer * 2.5;
    color: hevo-toolkit-variables.$grey-10;
    @include typography-level-to-styles(typography-config(), body-1);
  }

  .inviteBody {
    width: 60%;

    .accessHeader {
      padding: hevo-toolkit-variables.$spacer * 2 0 hevo-toolkit-variables.$spacer * 1.5;
      color: hevo-toolkit-variables.$text-default;
      @include typography-level-to-styles(typography-config(), body-3);
      border-bottom: solid hevo-toolkit-variables.$border-width
        hevo-toolkit-variables.$divider-color;
    }

    .roleGroupWrapper {
      padding-top: hevo-toolkit-variables.$spacer * 1.5;
      border-bottom: solid hevo-toolkit-variables.$border-width
        hevo-toolkit-variables.$divider-color;

      &.noBottomBorder {
        border-bottom: none;
      }

      .roleGroupTitle {
        margin-bottom: hevo-toolkit-variables.$spacer * 0.5;
        display: flex;
        align-items: center;
        gap: hevo-toolkit-variables.$spacer * 0.5;

        .checkboxLabel {
          color: hevo-toolkit-variables.$text-default;
          @include typography-level-to-styles(typography-config(), body-2);
        }
      }

      .roleGroupDescription {
        margin-bottom: hevo-toolkit-variables.$spacer * 1.5;
        color: hevo-toolkit-variables.$grey-10;
        @include typography-level-to-styles(typography-config(), body-1);
      }

      .rolesSection {
        border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
        border-radius: hevo-toolkit-variables.$border-radius-md;

        .roleItem {
          padding: hevo-toolkit-variables.$spacer hevo-toolkit-variables.$spacer * 0.75;
          border-bottom: solid hevo-toolkit-variables.$border-width
            hevo-toolkit-variables.$divider-color;

          &:last-child {
            border-bottom: none;
          }

          .roleSwitchWrapper {
            align-items: flex-start;
          }
        }
      }
    }
  }

  .buttonsSection {
    margin-top: hevo-toolkit-variables.$spacer * 2;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: hevo-toolkit-variables.$spacer;
  }
}

// used in workspace tab as well
.memberDropdown {
  width: 210px;
}

.popperContentClassName {
  max-width: 524px;
}

// ── Workspace Members Tab ─────────────────────────────────────────────────────

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  font-size: 14px;
  color: hevo-toolkit-variables.$grey-10;
}

.titleGroup {
  display: flex;
  flex-direction: column;
  height: 40px;
  gap: hevo-toolkit-variables.$spacer-4;
}

.titleText {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.084px;
  color: hevo-toolkit-variables.$text-strong-950;
}

.subtitleText {
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: hevo-toolkit-variables.$text-sub-600;
}

.wsHeaderActions {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
}

.nameInfo {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.nameRow {
  display: flex;
  align-items: center;
  gap: hevo-toolkit-variables.$spacer-8;
  flex-wrap: wrap;
}

.youLabel {
  font-weight: 400;
  color: hevo-toolkit-variables.$grey-10;
}

.emailText {
  font-size: 12px;
  color: hevo-toolkit-variables.$grey-10;
}

.dropdownWhitePaper {
  background: hevo-toolkit-variables.$surface-bg !important;
}

.wsFilterDropdown {
  width: 220px;

  :global(.MuiInputBase-root) {
    height: 32px;

    input {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
